import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PaymentSummaryReportRoutingModule } from './payment-summary-report-routing.module';
import { PaymentSummaryReportComponent } from './payment-summary-report.component';
import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { PsrFilterComponent } from './psr-filter/psr-filter.component';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    PaymentSummaryReportRoutingModule
  ],
  declarations: [PaymentSummaryReportComponent, PsrFilterComponent],
  entryComponents:[PsrFilterComponent]

})
export class PaymentSummaryReportModule { }
